export default __webpack_public_path__ + "static/media/IMG_5552.8391c868.jpg";